<template>
    <div class="dropdown" :class="{ opened: showDropdown, disable: disable}">
        <div class="current" @click="toggle">{{ current.name }}</div>

        <div v-show="showDropdown" class="dropdown-menu">
            <ul class="list">
                <li v-for="item in list"
                    :key="item.value"
                    class="item"
                    :class="{active : (item.value === current.value)}"
                    @click="select(item.value)"
                >{{ item.name }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: "DropdownDefault",

        props: [
            'current',
            'list',
            'disable',
        ],

        emits: [
            'select',
        ],

        data() {
            return {
                showDropdown: false,
            }
        },

        methods: {
            toggle() {
                if (this.showDropdown) {
                    this.close();
                }
                else {
                    this.open();
                }
            },

            open() {
                if (this.disable) return;

                this.showDropdown = true;
            },

            close() {
                this.showDropdown = false;
            },

            select(value) {
                this.$emit('select', value);

                this.close();
            },

            closeGlobal(e) {
                if (!this.showDropdown) return true;

                if (!e.target.closest('.dropdown')) {
                    this.close();
                }
            }

        },

        mounted() {
            window.addEventListener('click', this.closeGlobal);
        },

        beforeUnmount() {
            window.removeEventListener('click', this.closeGlobal);
        },

    }
</script>

<style scoped>
    .dropdown {
        position: relative;
    }

    .current {
        position: relative;
        z-index: 1;
        min-height: 35px;
        padding: 7px 40px 8px 12px;
        border: 1px solid #ccc;
        border-radius: 7px;
        font-family: inherit;
        font-size: 18px;
        line-height: 1;
        cursor: default;
    }

    .current::after {
        content: '';
        position: absolute;
        top: 14px;
        right: 12px;
        border: 5px solid transparent;
        border-top-color: #000;
    }

    .disable .current {
        color: #aaa;
        background: #eee;
        cursor: not-allowed;
    }

    .disable .current::after {
        border-top-color: #aaa;
    }

    .opened .current {
        border-radius: 7px 7px 0 0;
    }

    .dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1;
        width: 100%;
        margin: -1px 0 0;
        border: 1px solid #ccc;
        border-radius: 0 0 7px 7px;
        background: #fff;
    }

    .list {
        overflow: auto;
        max-height: 200px;
        margin: 0;
        padding: 5px 0;
        list-style: none;
    }

    .item {
        padding: 5px 12px;
        cursor: pointer;
    }

    .active {
        background: #eee;
    }

    .item:hover {
        background: #eee;
    }

</style>